import { useState, useEffect } from 'react';

export default function useIsTabletWidth(): boolean {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('only screen and (max-width: 1024px)');
    const handleMediaQueryChange = (event: MediaQueryListEvent) => {
      setIsTablet(event.matches);
    };

    setIsTablet(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleMediaQueryChange);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
    };
  }, []);

  return isTablet;
}
